var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-radio-group',{staticStyle:{"width":"100%"},model:{value:(_vm.changeValue),callback:function ($$v) {_vm.changeValue=$$v},expression:"changeValue"}},[_vm._l((_vm.options),function(item,index){return [_c('a-radio',{key:`radio_${index}`,attrs:{"value":item.value}},[_vm._v(" "+_vm._s(item.label)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }